<template>
  <div>
    <v-data-table
      :loading="isLoading"
      :headers="headers"
      :items="items"
      :items-per-page="5"
      :search="search"
      class="elevation-1 mb-10"
      @click:row="onRowClick"
      style="cursor: pointer;"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>
            <b>{{ $t(title) }}</b>
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="search-bar">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('table.search')"
              single-line
              hide-details
            ></v-text-field>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    headers: Array,
    items: Array,
    title: String,
    isLoading: Boolean
  },
  data: () => ({
    show: false,
    search: "",
    deleteDialog: false
  }),
  methods: {
    onRowClick(item) {
      this.$router.push({
        path: "pending-qualifications/details",
        query: {
          centreId: item.centreId,
          qualificationId: item.qualificationId
        }
      });
    }
  }
};
</script>

<style scoped>
.search-bar {
  width: 200px;
}
</style>